import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Inv3020SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    refNo: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    filterStatus: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv3020SearchParams = z.infer<typeof Inv3020SearchParamsSchema>

export const Inv3020SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  partyId: z.number().nullable(),
  refNo: z.string().nullable(),
  date: z.coerce.date(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
})

export type Inv3020SearchResultModel = z.infer<
  typeof Inv3020SearchResultModelSchema
>

export const Inv3020SearchResultSchema = z
  .object({
    data: z.array(Inv3020SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv3020SearchResult = z.infer<typeof Inv3020SearchResultSchema>
